<div class="item" *ngIf="getText().length>0">
  <div *ngFor="let rep of getText()">
    {{rep}}<br/>
  </div>
</div>
